import * as React from 'react';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Typography from '@mui/material/Typography';
import {faker} from '@faker-js/faker';
import paella from '../static/images/paella.jpg'
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import StarIcon from '@mui/icons-material/Star';
import Stack from '@mui/material/Stack';
import CommonAppbar from '../components/common/CommonAppbar';
import Box from '@mui/material/Box';
import DeveloperInfo from '../components/common/DeveloperInfo';

const otherApps = [{
  name: faker.commerce.department(),
  img: '',
  rating: 4.5
},
  {
    name: faker.commerce.department(),
    img: '',
    rating: 4.2
  },
  {
    name: faker.commerce.department(),
    img: '',
    rating: 4
  },
  {
    name: faker.commerce.department(),
    img: '',
    rating: 4
  }]

export default function OtherApps() {
  const [expanded, setExpanded] = React.useState(false);

  return (
    <>
      <CommonAppbar isMainPage={true} pageHeader={'Other Apps'}/>
      <DeveloperInfo> This page is not applicable for all apps. If it's not there we should remove it from navbar.
      </DeveloperInfo>

      <Box sx={{background: 'lightgrey', pr: 1, pl: 1}}>
        <Grid container spacing={1}>
          {otherApps.map(app => {
            return <Grid item xs={6}>
              <Card sx={{maxWidth: 300}} variant={'outlined'} onClick={() => {
                window.location.href = 'https://play.google.com/store/search?q=instagram&c=apps'
              }}>
                <CardMedia
                  component="img"
                  height="150"
                  image={paella}
                  alt="Paella dish"
                />
                <CardContent>
                  <Typography variant="h6">
                    {app.name}
                  </Typography>
                  <Stack direction={'row'}>
                    {app.rating}
                    <StarIcon/>
                  </Stack>


                </CardContent>
                <CardActions>
                  <Button size="small"
                          href={'https://play.google.com/store/search?q=instagram&c=apps'}>
                    Install
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          })}
        </Grid>
      </Box>
    </>
  );
}
